import send from '../../util/request';
import { objectToLine } from '../../util/convert';

export const sendMessageApi = (data = {}) => {
	return send({ url: '/ipp/message/send', method: 'POST', data: objectToLine(data) });
};

//物流追踪
export function purchaseGoodsLogistics(params) {
	return send({ url: '/ipp/order-purchase/logistics', params });
}

// 物流列表
export function getOrderPurchaseLogistics(params = {}) {
	return send({ url: '/ipp/order-purchase/logistics', method: 'POST', data: params });
}

// 国内物流报价单
export function getOrderInternalQuote(params = {}) {
	return send({ url: '/ipp/internal/quote', method: 'POST', data: params });
}

// 确认物流报价单
export function orderInternalConfirmQuote(params = {}) {
	return send({ url: '/ipp/internal/confirm-quote', method: 'POST', data: params });
}

// 国内轨迹查询
export function getOrderPurchaseTrack(params = {}) {
	return send({ url: '/ipp/order-purchase/track', method: 'POST', data: params });
}

// 关口质检
export function getPortQualityReportInfo(params = {}) {
	return send({ url: '/ipp/order-purchase/port-quality-report', method: 'POST', data: params });
}

// 大仓基本数据初始化
export function getQualityBaseInfo(params = {}) {
	return send({ url: '/ipp/quality/index', method: 'POST', data: params });
}

// 创建大仓质检
export function createQuality(params = {}) {
	return send({ url: '/ipp/quality/create', method: 'POST', data: params, options: { loading: true } });
}

// 大仓质检详情
export function getQualityDetail(params = {}) {
	return send({ url: '/ipp/quality/detail', method: 'GET', params, options: { loading: true } });
}

// 获取ossToken
export function getOssToken(params = {}) {
	return send({ url: '/ipp/common/oss-token', method: 'GET', params });
}

//新增编辑收货地址
export function internalCreateAddress(params = {}) {
	return send({ url: '/ipp/internal/create-address', method: 'POST', data: params, options: { loading: true } });
}

//收货地址详情
export function internalDetailAddress(params = {}) {
	return send({ url: '/ipp/internal/detail-address', method: 'POST', data: params, options: { loading: true } });
}

//转运信息编辑
export function internalCreateTransfer(params = {}) {
	return send({ url: '/ipp/internal/create-transfer', method: 'POST', data: params, options: { loading: true } });
}

//转运信息详情
export function internalDetailTransfer(params = {}) {
	return send({ url: '/ipp/internal/detail-transfer', method: 'POST', data: params, options: { loading: true } });
}

//获取svc客户列表
export function internalCompanyList(params = {}) {
	return send({ url: '/ipp/internal/company-lists', method: 'POST', data: params, options: { loading: true } });
}

//订单列表-再来一单
export function orderPurchaseAgainOrder(params = {}) {
	return send({ url: '/ipp/order-purchase/again-order', method: 'POST', data: params, options: { loading: true } });
}

export function qualityCreateAttachment(params = {}) {
	return send({ url: '/ipp/quality/create-attachment', method: 'POST', data: params, options: { loading: true } });
}

export function qualityDeleteAttachment(params = {}) {
	return send({ url: '/ipp/quality/delete-attachment', method: 'POST', data: params, options: { loading: true } });
}

// 保存大仓质检时间
export function orderPurchaseSaveWarehouseQualityTime(params = {}) {
	return send({ url: '/ipp/order-purchase/save-warehouse-quality-time', method: 'POST', data: params, options: { loading: true } });
}

// 质检小程序二维码
export function orderPurchaseQualityQrcode(params = {}) {
	return send({ url: '/ipp/order-purchase/quality-qrcode', method: 'POST', data: params, options: { loading: true } });
}
// 客户质量反馈详情
export function orderPurchaseCustomerQualityInfo(params = {}) {
	return send({ url: '/ipp/order-purchase/customer-feedback-info', method: 'POST', data: params, options: { loading: true } });
}
// 采购订单-ERP冲销订单
export function orderPurchaseErpReverse(params = {}) {
	return send({ url: '/ipp/order-purchase/erp-reverse', method: 'POST', data: params, options: { loading: true } });
}